;(function() {
  'use strict'

  angular.module('core.filters').filter('dateTime', filter)

  /* @ngInject */
  function filter() {
    return function(dateString) {
      return moment(dateString).format('dddd, MMMM Do YYYY @ h:mm a')
    }
  }
})()
